import { IHosProcessResult } from "../../services/hosProcess";
import { createAction, ActionsUnion } from "../definitions";
import { HosRuleResultsActionTypes } from "./types";

export interface IHosRuleResultPayload {
    userId?: string;
    ruleResult?: IHosProcessResult;
    afterSync?: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const HosRuleResultsActions = {
    setHosRuleResults: (payload: IHosRuleResultPayload) => createAction(HosRuleResultsActionTypes.SET_HOS_RULE_RESULTS, payload),
    clearHosRuleResults: (payload: IHosRuleResultPayload) => createAction(HosRuleResultsActionTypes.CLEAR_HOS_RULE_RESULTS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HosRuleResultsActions = ActionsUnion<typeof HosRuleResultsActions>;